import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CartSidebar } from '../CartSidebar';

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      {/* pt accounts for: announcement bar (~32px) + nav (~64px) */}
      <main className="flex-1 pt-24">
        <Outlet />
      </main>
      <Footer />
      <CartSidebar />
    </div>
  );
}